import React from 'react';
import {observer} from 'mobx-react';

@observer
export class NewAppConfirmation extends React.Component {

	constructor(props) {
		super(props);
	}

	render () {
		return(
			<div className="container">
				<h2>New App Confirmation Component</h2>
			</div>
		);
	}

}
